import React from 'react';
import Radium from 'radium';
import {Helmet} from "react-helmet";

import HeaderContainer from 'containers/HeaderContainer';
import Footer from 'views/Footer';

import {A} from 'views/AppElements';
import AppConstants from 'AppConstants';


const AppName = <b>{AppConstants.APP_NAME}</b>;
const SITE_URL = <b>{AppConstants.WEBSITE}</b>;
import AppUtil from 'AppUtil';


const ImageIcon = Radium((props) => {

	return <div className='flexRow' style={{alignItems: 'center', width: '80%', margin: '0 auto 30px auto', flexWrap: 'nowrap',
											'@media (max-width: 500px)': {flexWrap: 'wrap'},
											'@media (max-width: 770px)': {width: '100%', margin: '0 auto 20px auto'}}}>

		 	<img src={props.src} alt={props.title} style={{marginRight: '30px', maxWidth: '364px', 
		 									'@media (max-width: 364px)': {width: '100%'},
		 									'@media (max-width: 500px)': {maxWidth: '300px'},
		 									'@media (max-width: 770px)': {margin: 'auto'}}}/>

			<h1 style={{color: '#f8941c', margin: '20px 0', fontSize: '220%', 
							'@media (max-width: 770px)': {fontSize: '210%', textAlign: 'center', flexGrow: '1'}}}>{props.title}</h1>
	</div>
});

const WhatIsSC = Radium((props) => {

	return <div style={{margin: '20px auto', padding: '0 10px'}} id="howtoMakeMoney" className='scWidth'>
		
			<h4>{AppName} is a marketplace for creative heads like you to sell your art/design printed on different merchandise such as T-Shirts, Mugs, Pillows and <b>Make Money from Home</b> at your own convenience.</h4>
			
			<p><i>Currently, {AppConstants.APP_NAME} only entertain production of T-Shirts but we will expand it to other merchandise in the near future.</i></p>
			
			
			<img src="/images/about_us/how_does_it_work.png" alt="How Does SetoCanvas.com works"
					style={{margin: '40px auto 20px auto', display: 'block', width: '460px', 
																	'@media (max-width: 600px)': {width: '100%'}}}/>
			

			
			<div className='flexColumn' style={{marginTop: '40px'}}>
				<ImageIcon src="/images/about_us/design.png" title="1. Design a Beautiful Graphic Art."/>
				<ImageIcon src="/images/about_us/upload.png" title="2. Submit your designs." />

				
				<h4 style={{marginTop: '0'}}>An artist can submit their art/design, along with a print on a merchandise (such as a T-Shirt) on <A href={AppConstants.WEBSITE}>{SITE_URL}</A>. Our Team will then review your art/design and confirm if it abides to our <A target="_blank" href="/terms-of-use-and-privacy-policy">Term & Conditions</A>.
				Once the design is approved, the price of the product will be determined based on the number of colors your design has, the size of the design and few other variables, and the product will be made available for sale on <A href={AppConstants.WEBSITE}>{SITE_URL}</A>
				</h4>
				<br />

				<ImageIcon src="/images/about_us/sell.png" title="3. Promote your designs." />
				<ImageIcon src="/images/about_us/make_money.png" title="4. Make money of each sale." />

				<h4 style={{marginTop: '0'}}>{AppName} will then take complete responsibility of production, packaging and delivery of the merchandise. For every quantity sold, you (the Artist) will earn a certain amount of commission <i>(as described <A href="/how-much-can-i-make">here</A>)</i>. 
			We will also further promote and market your merchandise <b><i>but, it should be the primary responsibility of the Artist to promote his/her merchandise rather than depend on <A href={AppConstants.WEBSITE}>{AppName}</A> to market it.</i></b></h4>
			</div>


			

			
			
	</div>
});


class HowToMakeMoney extends React.Component {

	componentDidMount() {
		AppUtil.scrollToTop();
	}

	render() {
		return <div>
				<Helmet>
					<title>How to make Money on Seto Canvas? | Seto Canvas</title>
				</Helmet>
				<HeaderContainer />

				<WhatIsSC />
				
				<Footer />
		</div>
	}
}

export default HowToMakeMoney;




// WEBPACK FOOTER //
// ./src/pages/docs/HowToMakeMoney.js